{
  "uploader": {
    "debug": true
  },
  "rtrelay": {
    "url": "https://spotlight-preprod-storage-rtr.semantria.com",
    "context": "/rtr",
    "suppressErrors": true
  },
  "blender": {
    "url": "https://spotlight-preprod-storage-bknd.semantria.com"
  },
  "spotlightAgent": {
    "url": "https://spotlight-agent-preprod-b6b3c3dyg7hwhhbc.centralus-01.azurewebsites.net",
    "env": "preprod"
  },
  "aiAssistant": {
    "flowId": "a6cd6b21-f8ca-4f93-a628-2d39c461ea49",
    "flowiseUrl": "https://ai-studio-preprod-spoteflow.semantria.com/",
    "enabled": false
  }
}
